import moment from "moment";
import { DateUtils } from "~app/common/utils/date-utils";
import { Kundorder } from "~app/features/forsaljning/models/KundorderListResponseDTO";

export class TerminalSearchResultViewModel {
    constructor(private readonly model: Kundorder) {
    }

    get id() {
        return this.model.id;
    }

    get namn() {
        return this.model && this.model.mottagningsplats ? this.model.mottagningsplats.map(m => `${m.kod} ${m.namn}`) : "";
    }

    get periodFrom() {
        if (!this.model.periodFrom) {
            return "";
        }

        return moment(this.model.periodFrom).format(DateUtils.dateformat);
    }

    get periodTom() {
        if (!this.model.periodTom) {
            return "";
        }

        return moment(this.model.periodTom).format(DateUtils.dateformat);
    }

    get ordernummer() {
        return this.model.ordernummer;
    }

    get handelssortiment() {
        return this.model && this.model.handelssortiment ? this.model.handelssortiment.map(h => `${h.beteckning} ${h.namn}`) : "";
    }

    get kvantitet() {
        return `${this.model.kvantitet} ${this.model.mattslag}`;
    }

    get avtalsansvarig() {
        return this.model.avtalsansvarig;
    }

    get beskrivning() {
        return this.model.beskrivning;
    }
}
